"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeekDayLabelHTML = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var luxon_1 = require("luxon");
var clsx_1 = __importDefault(require("clsx"));
var FONT_SIZE = 12;
var WeekDayLabelHTML = function (_a) {
    var x = _a.x, y = _a.y, font = _a.font, todayFillColor = _a.todayFillColor, labelColor = _a.labelColor, dateString = _a.date, today = _a.today, additionalText = _a.additionalText, limited = _a.limited, highContrast = _a.highContrast;
    var date = luxon_1.DateTime.fromISO(dateString, { zone: "utc" }).startOf("day");
    var printableDate = date.toFormat("d");
    if (parseInt(printableDate) === 1) {
        printableDate = date.toFormat("MMM d");
    }
    return ((0, jsx_runtime_1.jsxs)("p", __assign({ style: {
            paddingLeft: x !== null && x !== void 0 ? x : 0,
            paddingTop: y !== null && y !== void 0 ? y : 0,
            fontSize: FONT_SIZE - (limited ? 4 : 0),
            fontFamily: font,
            lineHeight: "1em",
        }, className: "w-full flex mb-auto" }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ style: {
                    color: today ? "#fff" : labelColor,
                    background: today ? todayFillColor : "",
                    padding: 2,
                }, className: (0, clsx_1.default)(today && "rounded m3-2", highContrast && "font-bold") }, { children: printableDate }), void 0), additionalText ? ((0, jsx_runtime_1.jsx)("span", __assign({ style: {
                    color: labelColor,
                    padding: 2,
                } }, { children: additionalText }), void 0)) : null] }), void 0));
};
exports.WeekDayLabelHTML = WeekDayLabelHTML;
